import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteArea } from "src/Pages/Company/OrganizationStructure/api";
import { useHistory } from "react-router-dom";
import { useContext } from "react";
import RbsContext from "src/utils/RoleBasedSecurity/RbsContext";
import useBasePath from "src/utils/hooks/useBasePath";

export interface IDeleteArea {
  companyId: string;
  structureId: string;
  areaId: string;
}

const useDeleteArea = ({ companyId, structureId, areaId }: IDeleteArea) => {
  const queryClient = useQueryClient();
  const history = useHistory();
  const { userInfo } = useContext(RbsContext);
  const isAhr = userInfo.isAhr();
  const basePath = useBasePath();

  return useMutation({
    mutationFn: () => deleteArea({ companyId, structureId, areaId }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["delete-area", companyId, structureId, areaId],
      });
      history.push(
        isAhr
          ? `/ahr/organization-structure/configure-structure/structure-areas`
          : `/company/edit/${companyId}/organization-structure/configure-structure/structure-areas`
      );
    },
  });
};

export default useDeleteArea;
